import { FormModel } from 'components/Form';
import { Validators } from 'utils/validators';

export const AddEditVenueMappingsForm = (_strings: any, venues: any[] = []): FormModel[] => {
  return [
    {
      label: 'BBR Venue',
      value: '',
      size: 'medium',
      type: 'select',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: 'Select BBR venue',
      field: 'venue',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12 },
      required: true,
      options: venues,
    },
    {
      label: 'IDS Venue Name',
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: 'IDS venue name',
      field: 'venueName',
      validators: [
        { check: Validators.validateMandatoryField },
        { check: Validators.validateString, max: 100 },
      ],
      responsive: { xs: 12 },
      required: true,
    },
    {
      label: 'IDS Venue Code',
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: 'IDS venue code',
      field: 'venueCode',
      validators: [
        { check: Validators.validateMandatoryField },
        { check: Validators.validateString, max: 50 },
      ],
      responsive: { xs: 12 },
      required: true,
    },
  ];
};
